<div class="print-options-dialog">  <h2 mat-dialog-title class="dialog-title">
    <mat-icon>print</mat-icon>
    {{ 'BRANCH_FOOD.TABLES.PRINT_OPTIONS_TITLE' | translate }}
  </h2>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-description">
      {{ 'BRANCH_FOOD.TABLES.PRINT_OPTIONS_DESCRIPTION' | translate }}
    </p>

    <div class="options-section">
      <h3 class="section-title">{{ 'BRANCH_FOOD.TABLES.SELECT_CONTENT' | translate }}</h3>
      
      <div class="options-list">        <mat-checkbox 
          [(ngModel)]="printOptions.includeQrCode" 
          disabled
          class="option-item">
          <div class="option-content">
            <mat-icon>qr_code</mat-icon>
            <span>{{ 'BRANCH_FOOD.TABLES.QR_CODE' | translate }}</span>
            <small class="required-label">({{ 'BRANCH_FOOD.TABLES.REQUIRED' | translate }})</small>
          </div>
        </mat-checkbox>

        <mat-checkbox 
          [(ngModel)]="printOptions.includeTitle" 
          class="option-item">
          <div class="option-content">
            <mat-icon>title</mat-icon>
            <span>{{ 'BRANCH_FOOD.TABLES.TITLE_HEADER' | translate }}</span>
          </div>
        </mat-checkbox>

        <mat-checkbox 
          [(ngModel)]="printOptions.includeTableInfo" 
          class="option-item">
          <div class="option-content">
            <mat-icon>table_restaurant</mat-icon>
            <span>{{ 'BRANCH_FOOD.TABLES.TABLE_INFORMATION' | translate }}</span>
          </div>
        </mat-checkbox>        <mat-checkbox 
          [(ngModel)]="printOptions.includeFloorInfo" 
          class="option-item">
          <div class="option-content">
            <mat-icon>layers</mat-icon>
            <span>{{ 'BRANCH_FOOD.TABLES.FLOOR_INFORMATION' | translate }}</span>
          </div>
        </mat-checkbox>

        <mat-checkbox 
          [(ngModel)]="printOptions.includeInstructions" 
          class="option-item">
          <div class="option-content">
            <mat-icon>help_outline</mat-icon>
            <span>{{ 'BRANCH_FOOD.TABLES.SCAN_INSTRUCTIONS' | translate }}</span>
          </div>
        </mat-checkbox>
      </div>

      <div class="quick-actions">
        <button mat-button color="primary" (click)="selectAll()" class="quick-action-btn">
          <mat-icon>select_all</mat-icon>
          {{ 'BRANCH_FOOD.TABLES.SELECT_ALL' | translate }}
        </button>
        <button mat-button (click)="deselectAll()" class="quick-action-btn">
          <mat-icon>deselect</mat-icon>
          {{ 'BRANCH_FOOD.TABLES.DESELECT_ALL' | translate }}
        </button>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="onCancel()" class="cancel-btn">
      {{ 'BRANCH_FOOD.TABLES.CANCEL' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="onPrint()" class="print-btn">
      <mat-icon>print</mat-icon>
      {{ 'BRANCH_FOOD.TABLES.PRINT' | translate }}
    </button>
  </mat-dialog-actions>
</div>
